module.exports = __webpack_public_path__ + "media/images/ricepaper2-4210a9ec2cd173dd7ac5781940b276fa.png";